export default __webpack_public_path__ + "images/KT.27b6cba.png";